// extracted by mini-css-extract-plugin
module.exports = {"title":"Home_title__utdWP","gradientUp":"Home_gradientUp__V8XQh","ascents":"Home_ascents__4jG_L"};